import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "publish-channel-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "delete-area" }
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "模板信息", -1)
const _hoisted_8 = { class: "flex justify-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: "发布成功",
    width: "700px",
    onCancel: _ctx.handleConfirm
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 确定 ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { style: { marginBottom: '20px' } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 8,
              class: "left-col"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 封面图 "),
                _createElementVNode("img", {
                  src: _ctx.page.coverImg,
                  alt: _ctx.page.title
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 16,
              class: "right-col"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.DEFAULT_COVER_IMAGE,
                          alt: _ctx.page.title
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 18,
                      class: "left-gap"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.page.title), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.page.desc), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tabs, {
                  activeKey: _ctx.activeTab,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
                  type: "card",
                  style: { marginTop: '20px' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "channels",
                      tab: "发布为作品"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (channel) => {
                          return (_openBlock(), _createBlock(_component_a_row, {
                            key: channel.id,
                            class: "channel-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("canvas", {
                                    id: `channel-barcode-${channel.id}`,
                                    class: "barcode-container"
                                  }, null, 8, _hoisted_4)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, {
                                span: 18,
                                class: "left-gap"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(channel.name), 1),
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 18 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            id: `channel-url-${channel.id}`,
                                            value: _ctx.generateChannelURL(channel.id),
                                            readonly: true
                                          }, null, 8, ["id", "value"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            class: "copy-button",
                                            "data-clipboard-target": `#channel-url-${channel.id}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" 复制 ")
                                            ]),
                                            _: 2
                                          }, 1032, ["data-clipboard-target"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_a_button, {
                                  type: "danger",
                                  size: "small",
                                  disabled: _ctx.deleteDisabled,
                                  onClick: ($event: any) => (_ctx.deleteChannel(channel.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 删除渠道 ")
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_a_form, {
                          layout: "inline",
                          style: { marginTop: '20px' },
                          model: _ctx.form,
                          rules: _ctx.rules
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "channelName" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: _ctx.form.channelName,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.channelName) = $event)),
                                  placeholder: "渠道名称"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  loading: _ctx.createChannelLoading,
                                  type: "primary",
                                  onClick: _ctx.createChannel
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 创建新渠道 ")
                                  ]),
                                  _: 1
                                }, 8, ["loading", "onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "template",
                      tab: "发布为模版"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.defaultChannel], (template) => {
                          return (_openBlock(), _createBlock(_component_a_row, {
                            key: template.id,
                            class: "channel-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("canvas", {
                                    id: `template-barcode-${template.id}`,
                                    class: "barcode-container"
                                  }, null, 8, _hoisted_6)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, {
                                span: 18,
                                class: "left-gap"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7,
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 18 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            id: `template-url-${template.id}`,
                                            value: _ctx.generateChannelURL(template.id),
                                            readonly: true
                                          }, null, 8, ["id", "value"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            class: "copy-button",
                                            "data-clipboard-target": `#template-url-${template.id}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" 复制 ")
                                            ]),
                                            _: 2
                                          }, 1032, ["data-clipboard-target"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            loading: _ctx.publishAsTempLoading,
                            onClick: _ctx.publishAsTemplate
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 发布模板 ")
                            ]),
                            _: 1
                          }, 8, ["loading", "onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}